import { useEffect as S, useState as v, useReducer as R, useCallback as M, useRef as I } from "react";
const Q = () => {
  S(() => {
    console.log("Hello, world!");
  });
}, $ = {
  email: /^[a-zA-Z0-9+._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/,
  // credit card must contains only numbers, no white space
  "credit-card": /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|(222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11}|62[0-9]{14})$/,
  // password must contain at least one number, capital letter, lowercase letter, and special character
  // password must be at least 6 characters long
  password: /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,}$/,
  // zip code must either be five numbers long or 5 numbers followed by a '-' and 4 numbers
  "zip-code": /(^\d{5}$)|(^\d{5}-\d{4}$)/,
  "canadian-zip": /([ABCEGHJKLMNPRSTVXY]\d)([ABCEGHJKLMNPRSTVWXYZ]\d){2}/,
  // cannot include country code, 10 digits with or without "-", ".", or " " between number groupings
  "phone-number": /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
  // https://gist.github.com/dperini/729294
  url: /^(?:(?:(?:https?):)?\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z0-9\u00a1-\uffff][a-z0-9\u00a1-\uffff_-]{0,62})?[a-z0-9\u00a1-\uffff]\.)+(?:[a-z\u00a1-\uffff]{2,}\.?))(?::\d{2,5})?(?:[/?#]\S*)?$/i
}, F = (e) => (s) => s.length === 0 ? !0 : Array.isArray(e) ? e.every((o) => o.test(s)) : e instanceof RegExp ? e.test(s) : $[e].test(s), j = (e, t) => {
  const [s, o] = v(e), n = F(t);
  return [s, o, n(s)];
}, T = (e, t, s, o, n) => {
  var c;
  const a = e.replace(/[^0-9]+/g, ""), r = new RegExp(`.{1,${t}}`, "g"), l = a.match(r);
  if (n && a.length > n) {
    const i = a.substring(0, n), g = a.substring(n), f = ((c = i.match(r)) == null ? void 0 : c.join(s)) + g;
    return o && a.length > o ? f.substring(0, o + 2) : f;
  }
  if (l) {
    if (o && a.length > o)
      return l.join(s).substring(0, o + 1);
    if (a.length > t)
      return l.join(s);
  }
  return a;
}, A = {
  "credit-card": (e) => T(e, 4, " "),
  "zip-code": (e) => T(e, 5, "-", 9),
  "expiration-date": (e) => T(e, 2, "/", 4),
  "phone-number": (e) => T(e, 3, "-", 10, 7)
}, V = (e) => {
  const { initialState: t } = e, s = e, o = e, n = s.mask ? s.mask : o.validationMask, a = s.mask ? s.validation : o.validationMask;
  return { initialState: t, mask: n, validation: a };
}, C = (e, t) => {
  const [s, o] = v(e);
  return [s, (a) => {
    const r = typeof t == "function" ? t : A[t];
    o(r(a));
  }];
}, G = (e) => {
  const { initialState: t, mask: s, validation: o } = V(
    e
  ), [n, a] = C(t, s), r = F(o), l = typeof n == "string" && r(n);
  return [n, a, l];
}, K = (e, t) => {
  const [s, o] = v(() => {
    try {
      const a = window.localStorage.getItem(t);
      return a ? JSON.parse(a) : e;
    } catch (a) {
      return console.log(a), e;
    }
  });
  return [s, (a) => {
    try {
      const r = a instanceof Function ? a(s) : a;
      o(r), window.localStorage.setItem(t, JSON.stringify(r));
    } catch (r) {
      console.log(r);
    }
  }];
}, N = (e, t) => {
  const { initialState: s, mask: o } = e, [n, a] = C(s, o), [r, l] = K(
    n,
    t
  );
  return S(() => {
    a(r);
  }, [r]), [n, l];
}, W = (e, t) => {
  const { initialState: s, mask: o, validation: n } = V(
    e
  ), [a, r] = N(
    { initialState: s, mask: o },
    t
  ), l = F(n);
  return [a, r, l(a)];
}, _ = () => {
  const [e, t] = v({
    width: window.innerWidth,
    height: window.innerHeight
  });
  return S(() => {
    const s = (n) => {
      const { width: a, height: r } = n[0].contentRect;
      t({ width: a, height: r });
    }, o = new ResizeObserver(s);
    return o.observe(document.documentElement), () => {
      o.unobserve(document.documentElement);
    };
  }, []), e;
}, X = () => {
  const e = navigator.userAgent;
  let t;
  switch (!0) {
    case (e.includes("Safari") && !e.includes("Chrome") || e.search("Safari") >= 0 && e.search("Chrome") < 0):
      t = "Safari";
      break;
    case (e.includes("Edg") || e.match(/edg/i)):
      t = "Edge";
      break;
    case (e.includes("Chrome") || e.match(/chrome|chromium|crios/i)):
      t = "Chrome";
      break;
    case (e.includes("Firefox") || e.match(/firefox|fxios/i)):
      t = "Firefox";
      break;
    case (e.includes("Opera") || e.match(/opr\//i)):
      t = "Opera";
      break;
    default:
      t = "Other";
  }
  return t;
}, Y = (e) => {
  const [t, s] = v(e), [o, n] = v(!1);
  return S(() => {
    if (!t)
      return () => {
      };
    const r = window.matchMedia(t), l = (i) => {
      n(i.matches);
    }, c = (i) => {
      l(i);
    };
    return r.addEventListener && r.addEventListener("change", l), r.onchange = c, n(r.matches), () => {
      r.removeEventListener && r.removeEventListener("change", l), r.onchange = null;
    };
  }, [t]), [o, (r) => {
    s(r);
  }];
}, U = (e, t) => {
  var w;
  const [s, o] = v(!1), n = (h, y) => {
    switch (y.type) {
      case "setPage":
        return { ...h, page: y.page };
      case "setData":
        return {
          ...h,
          data: y.data,
          totalItems: y.totalItems,
          totalPages: Math.ceil(y.totalItems / h.pageSize)
        };
      case "setPageSize":
        return {
          ...h,
          pageSize: y.pageSize,
          totalPages: y.totalPages,
          page: y.page
        };
      case "setLoading":
        return {
          ...h,
          loading: y.loading
        };
      default:
        throw new Error(`Invalid pagination action: ${y}`);
    }
  }, [
    { page: a, totalPages: r, data: l, loading: c, pageSize: i, totalItems: g },
    f
  ] = R(n, {
    ...e,
    page: 1,
    data: ((w = e.sourceData) == null ? void 0 : w.slice(0, e.pageSize)) || [],
    sourceData: e.sourceData,
    totalItems: e.sourceData ? e.sourceData.length : 0,
    loading: !1,
    totalPages: 1
  }), b = (h, y) => h >= 1 && h <= y, u = (h) => {
    b(h, r) && f({ type: "setPage", page: h });
  }, E = (h) => {
    const y = Math.ceil(g / h);
    f({
      type: "setPageSize",
      pageSize: h,
      totalPages: y,
      page: b(a, y) ? a : 1
    });
  };
  return S(() => {
    if (e.fetchData && (f({ type: "setLoading", loading: !0 }), e.fetchData({
      page: a,
      pageSize: i
    }).then((h) => {
      h.resetPage && f({
        type: "setPage",
        page: h.resetPage
      }), f({
        type: "setData",
        data: h.data,
        totalItems: h.totalItems
      }), f({ type: "setLoading", loading: !1 }), o(!1);
    })), e.sourceData) {
      const h = i * (a - 1), y = a * i;
      f({
        type: "setData",
        data: e.sourceData.slice(h, y),
        totalItems: e.sourceData.length
      }), o(!1);
    }
  }, [a, i, s, ...t || []]), {
    page: a,
    setPage: u,
    totalPages: r,
    pageSize: i,
    setPageSize: E,
    data: l,
    loading: c,
    totalItems: g,
    refetch: () => o(!0)
  };
}, D = (e) => {
  switch (typeof e) {
    case "string":
      return e.length > 0;
    case "boolean":
      return e.toString();
    default:
      return e;
  }
}, B = (e, t) => e.every((s) => t[s]), H = (e, t) => {
  let s = [];
  return e.forEach((o) => {
    s = t[o] ? [...s.filter((a) => a !== o)] : s = [...s, o];
  }), s;
}, ee = (e) => {
  const [t, s] = v([]), o = (r) => {
    t.every((l) => l !== r) && s([...t, r]);
  }, n = () => {
    const r = Object.keys(e);
    return r.forEach((c) => {
      D(e[c]) && o(c);
    }), r.reduce((c, i) => D(e[i]) ? {
      ...c,
      [i]: typeof e[i].type == "boolean" ? !!e[i] : e[i]
    } : c, {});
  }, a = (r) => {
    let l = !0, c = !0, i = [], g = [], f = [];
    return r.forEach((b) => {
      typeof b == "boolean" && (g = [...g, b]), typeof b == "string" && (f = [...f, b]);
    }), l = g.every((b) => b), c = B(f, e), i = H(f, e), {
      validForm: l && c,
      missingFields: i
    };
  };
  return { formData: n(), isValidForm: a, touched: t };
}, te = (e, t) => {
  S(() => {
    const s = (o) => {
      if (Array.isArray(e)) {
        if (e.some((n) => {
          var a;
          return (a = n.current) == null ? void 0 : a.contains(o.target);
        }))
          return;
        t(o);
      } else {
        const n = e.current;
        if (!n || n.contains(o.target))
          return;
        t(o);
      }
    };
    return document.addEventListener("mousedown", s), document.addEventListener("touchstart", s), () => {
      document.removeEventListener("mousedown", s), document.removeEventListener("touchstart", s);
    };
  }, [e, t]);
}, ne = (e, {
  immediate: t = !0,
  sequential: s = !1
} = {}) => {
  const [o, n] = v("idle"), [a, r] = v(null), [l, c] = v(null), g = M(((f) => (n("pending"), r(null), c(null), Array.isArray(f) ? s ? f.reduce((u, E) => u.then(
    (z) => E.then((w) => [...z, w])
  ), Promise.resolve([])).then((u) => {
    r(u), n("success");
  }).catch((u) => {
    c(u), n("error");
  }) : Promise.allSettled(f).then((u) => {
    r(u), n("success");
  }).catch((u) => {
    c(u), n("error");
  }) : (f instanceof Function ? f : () => f)().then((u) => {
    r(u), n("success");
  }).catch((u) => {
    c(u), n("error");
  }))).bind(null, e), [e]);
  return S(() => {
    t && g();
  }, []), [g, o, a, l];
}, se = (e, t) => {
  const [s, o] = v(e);
  return S(
    () => {
      const n = setTimeout(() => {
        o(e);
      }, t);
      return () => {
        clearTimeout(n);
      };
    },
    [e, t]
    // Only re-call effect if value or delay changes
  ), s;
};
function re(e, t) {
  const s = I(), o = I();
  function n() {
    o.current && clearTimeout(o.current);
  }
  return S(() => n, []), function(...r) {
    s.current = r, n(), o.current = setTimeout(() => {
      s.current && e(...s.current);
    }, t);
  };
}
const oe = (e, t) => {
  const s = I("keyboard"), [o, n] = v(!1);
  return S(() => {
    const a = {
      keyboard: (i) => {
        i.metaKey || i.altKey || i.ctrlKey || (s.current = "keyboard");
      },
      pointer: () => {
        n(!1), s.current = "pointer";
      }
    }, r = {
      on: () => {
        n(!0), t != null && t.onKeyboardFocus && t.onKeyboardFocus();
      },
      off: () => {
        n(!1), t != null && t.onKeyboardBlur && t.onKeyboardBlur();
      }
    }, l = () => {
      s.current === "keyboard" && r.on();
    }, c = e.current;
    return c && (c.addEventListener("focus", l), c.addEventListener("blur", r.off), c.addEventListener("keydown", r.on, !0)), document.addEventListener("keydown", a.keyboard, !0), document.addEventListener("mousedown", a.pointer, !0), document.addEventListener("pointerdown", a.pointer, !0), document.addEventListener("touchstart", a.pointer, !0), () => {
      c && (c.removeEventListener("focus", l), c.removeEventListener("blur", r.off), c.removeEventListener("keydown", r.on, !0)), document.removeEventListener("keydown", a.keyboard, !0), document.removeEventListener("mousedown", a.pointer, !0), document.removeEventListener("pointerdown", a.pointer, !0), document.removeEventListener("touchstart", a.pointer, !0);
    };
  }, [e, t]), o;
}, ae = ({
  pathname: e,
  routes: t,
  defaultOpen: s = !0,
  exactRoute: o = !0
}) => {
  const [n, a] = v(!!s), [r, l] = v(), c = M(
    (g) => g ? o ? g.to === e : e.includes(g.to) : !1,
    [o, e]
  ), i = () => {
    const g = t == null ? void 0 : t.some((u) => u.to === e), f = t == null ? void 0 : t.filter((u) => c(u)), [b] = Array.isArray(f) ? f : [];
    a((u) => (l(u && g ? b : void 0), !u));
  };
  return S(() => {
    const g = c(r);
    !n && !g && l(void 0);
  }, [e, r, n, c]), [n, i, r];
}, ce = (e, t) => {
  const s = I(e);
  S(() => {
    s.current = e;
  }, [e]), S(() => {
    function o() {
      s.current();
    }
    if (t !== null) {
      const n = setInterval(o, t);
      return () => clearInterval(n);
    }
  }, [t]);
}, ie = (e, t) => {
  const [s, o] = v(!1);
  return S(() => {
    let n;
    return e && !s ? o(!0) : !e && s && (n = setTimeout(() => o(!1), t)), () => clearTimeout(n);
  }, [e, t, s]), s;
}, ue = (e, t) => {
  const [s, o] = v(!1), n = I([]), a = (m, p) => {
    switch (p.type) {
      case "setPage":
        return { ...m, page: p.page };
      case "setData":
        return {
          ...m,
          currentPageData: p.currentPageData,
          totalItems: p.totalItems !== void 0 ? p.totalItems : m.totalItems,
          totalPages: Math.ceil(
            (p.totalItems || m.totalItems) / m.pageSize
          )
        };
      case "setNextPageToken":
        return {
          ...m,
          nextPageToken: p.nextPageToken
        };
      case "setPageSize":
        return {
          ...m,
          pageSize: p.pageSize,
          totalPages: p.totalPages,
          page: p.page
        };
      case "setLoading":
        return {
          ...m,
          loading: p.loading
        };
      default:
        throw new Error(`Invalid pagination action: ${p}`);
    }
  }, [
    {
      page: r,
      totalPages: l,
      currentPageData: c,
      loading: i,
      pageSize: g,
      totalItems: f,
      nextPageToken: b
    },
    u
  ] = R(a, {
    ...e,
    page: 1,
    currentPageData: [],
    totalItems: 0,
    loading: !1,
    totalPages: 1
  }), E = (m, p) => m >= 1 && m <= p, z = (m) => {
    E(m, r + 1) && u({ type: "setPage", page: m });
  }, w = (m) => {
    const p = Math.ceil(f / m);
    n.current = [], u({
      type: "setPageSize",
      pageSize: m,
      totalPages: p,
      page: 1
    });
  }, h = I(!1);
  S(() => {
    let m = !1;
    u({ type: "setLoading", loading: !0 });
    const p = n.current.find(
      (d) => d.pageNumber === r
    );
    return p ? (u({
      type: "setData",
      currentPageData: p.data,
      page: r
    }), u({ type: "setLoading", loading: !1 })) : e.fetchData({
      page: r,
      pageSize: g,
      nextPageToken: b
    }).then(
      (d) => {
        m || (n.current = [
          ...n.current,
          { pageNumber: r, data: d.data }
        ], u({
          type: "setNextPageToken",
          nextPageToken: d.nextPageToken
        }), u({
          type: "setData",
          currentPageData: d.data,
          totalItems: d.totalItems,
          page: r
        }), u({ type: "setLoading", loading: !1 }), o(!1), h.current = !0);
      }
    ), () => {
      m = !0;
    };
  }, [r, s]), S(() => {
    h.current && y();
  }, [g, ...t || []]);
  const y = () => {
    n.current = [], u({ type: "setPage", page: 1 }), u({ type: "setNextPageToken", nextPageToken: void 0 }), o(!0);
  }, x = (m) => {
    let p;
    const d = n.current.find(({ data: k }) => {
      const L = k.find((O) => m(O));
      return p = L, L;
    }), P = d == null ? void 0 : d.data.findIndex((k) => m(k));
    return d != null && d.pageNumber && P !== void 0 && P >= 0 ? { page: d.pageNumber, index: P, existingItem: p } : void 0;
  };
  return {
    page: r,
    setPage: z,
    totalPages: l,
    pageSize: g,
    setPageSize: w,
    currentPageData: c,
    loading: i,
    totalItems: f,
    refetch: y,
    updateRow: (m, p) => {
      const d = x(m);
      if (d != null && d.page && (d == null ? void 0 : d.index) >= 0 && (d != null && d.existingItem))
        if (d.page === r) {
          const P = [
            ...c.slice(0, d.index),
            { ...d.existingItem, ...p },
            ...c.slice(d.index + 1)
          ];
          u({ type: "setData", currentPageData: P, page: r }), n.current = [
            ...n.current.filter((k) => k.pageNumber !== r),
            { pageNumber: r, data: P }
          ];
        } else {
          const P = n.current[d.page - 1].data, k = [
            ...P.slice(0, d.index),
            { ...d.existingItem, ...p },
            ...P.slice(d.index + 1)
          ];
          n.current = [
            ...n.current.filter((L) => L.pageNumber !== d.page),
            { pageNumber: d.page, data: k }
          ];
        }
    },
    findCachedRow: x
  };
}, de = (e, t) => {
  const [s, o] = v(!1);
  return S(() => {
    const n = t || "0px", a = new IntersectionObserver(
      ([r]) => {
        o(r.isIntersecting);
      },
      {
        rootMargin: n
      }
    );
    return e != null && e.current && a.observe(e.current), () => {
      e != null && e.current && a.unobserve(e.current);
    };
  }, []), s;
}, le = () => {
  const [e, t] = v(!1), s = (o, n) => {
    navigator.clipboard.writeText(o).then(() => {
      console.log(`successfully copied ${n || ""}`), t(!0);
    }).catch((a) => console.error(`could not copy ${n || ""}`, a));
  };
  return S(() => {
    e && (() => new Promise((n) => {
      setTimeout(() => {
        t(!1), n();
      }, 4e3);
    }))();
  }, [e]), [s, e];
}, Z = {
  sort: void 0,
  filter: void 0
}, ge = () => {
  const [e, t] = v(Z);
  return {
    ...e,
    clearSort: () => t((c) => ({ ...c, sort: void 0 })),
    clearFilter: (c) => t((i) => {
      var f;
      const g = { ...i };
      return (f = g.filter) == null || delete f[c], g;
    }),
    clearAllFilters: () => t((c) => ({ ...c, filter: void 0 })),
    resetTable: () => t(() => ({ filter: void 0, sort: void 0 })),
    setSort: (c, i) => t((g) => ({ ...g, sort: { field: c, direction: i } })),
    addFilter: (c, i) => t((g) => ({
      ...g,
      filter: { ...g.filter, [c]: i }
    }))
  };
};
export {
  V as seperateValidationMask,
  ne as useAsync,
  X as useBrowser,
  le as useCopy,
  se as useDebounce,
  re as useDebouncedCallback,
  ie as useDelayUnmount,
  ee as useForm,
  ae as useGroupMenu,
  Q as useHelloWorld,
  ce as useInterval,
  oe as useKeyboardFocus,
  N as useLocalMask,
  K as useLocalStorage,
  W as useLocalValidatedMask,
  C as useMask,
  Y as useMediaQuery,
  te as useOnClickOutside,
  de as useOnScreen,
  U as usePagination,
  _ as useScreenSize,
  ge as useTable,
  ue as useTokenPagination,
  G as useValidatedMask,
  j as useValidatedState,
  F as useValidation,
  $ as validationRegEx
};
//# sourceMappingURL=index.mjs.map
